import { registerIcon } from "@ui5/webcomponents-base/dist/asset-registries/Icons.js";

const name = "time-entry-request";
const pathData = "M256.5 103q11 0 18 7.5t7 18.5v120l72 95q5 8 4 19t-9 16q-8 6-19.5 4.5t-16.5-9.5l-77-102q-2-4-3.5-7.5t-1.5-7.5V129q0-11 7-18.5t19-7.5zm0-102q53 0 99 20t81 55 55 81.5 20 99.5q0 52-20 98.5t-55 81.5-81 55-99 20q-26 0-26-25 0-26 26-26 42 0 79-16t65-44 44-65 16-79-16-79.5-44-65.5-65-44-79-16q-39 0-74.5 14t-62.5 38.5-44 57.5-21 72q-2 9-10.5 16t-17.5 7q-12-2-18.5-10.5T3.5 229q6-48 27.5-89.5T86.5 67 164 18.5 256.5 1zm-103 307q26 0 26 25 0 26-26 26h-127q-26 0-26-26 0-25 26-25h127zm0 76q12 0 19 7.5t7 18.5-7 18.5-19 7.5h-127q-12 0-19-7.5T.5 410t7-18.5 19-7.5h127zm0 77q26 0 26 26 0 25-26 25h-127q-26 0-26-25 0-26 26-26h127z";
const ltr = false;
const accData = null;
const collection = "SAP-icons-v5";
const packageName = "@ui5/webcomponents-icons";

registerIcon(name, { pathData, ltr, collection, packageName });

export default "SAP-icons-v5/time-entry-request";
export { pathData, ltr, accData };